import { Textarea, TextareaProps } from '@chakra-ui/react';
import { FieldPath, UseFormReturn } from 'react-hook-form';

type MenuDescriptionTextareaProps<TFieldValues> = TextareaProps & {
  name: FieldPath<TFieldValues>;
  register: UseFormReturn<TFieldValues>['register'];
};

export const MenuDescriptionTextarea = <TFieldValues,>({
  name,
  register,
  ...textareaProps
}: MenuDescriptionTextareaProps<TFieldValues>) => (
  <Textarea
    type="text"
    {...register(name, {
      required: '必須項目です。',
      maxLength: {
        value: 255,
        message: '説明は255文字以内にする必要があります。',
      },
    })}
    {...textareaProps}
  />
);
